/**
 * This exception is thrown when a reward cannot be redeemed.
 */
export class RewardCannotBeRedeemedException extends Error {}
